import * as dayjs from 'dayjs';
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'hour',
})
export class HourPipe implements PipeTransform {
  transform(time: string): string {
    const [hours, minutes, seconds] = time.split(':').map((value) => +value);
    const date = dayjs().set('hours', hours).set('minutes', minutes);
    const formatted = date.format('HH:mm');

    return formatted;
  }

  constructor() {
    dayjs().locale('se');
  }
}
